import type { UsageTabKey } from '../../types';
import { DimensionType } from '../../types';
import { CHILD_TO_PARENT_DIMENSIONS, V1_SDK_METADATA_KEYS } from '../constants/metricDimensions';
import { usageTabConfig } from '../constants/usageTabConfig';

export function getGroupByDimensions(usageTab: UsageTabKey, dimension: DimensionType): DimensionType[] {
  const availableDimensions = usageTabConfig[usageTab].dimensions;
  return [dimension, ...(CHILD_TO_PARENT_DIMENSIONS[dimension]?.filter((d) => availableDimensions.includes(d)) ?? [])];
}

export function getDimensionMetadataKey(dimension?: DimensionType): string {
  return dimension === DimensionType.ANONYMOUS_V2 ? 'anonymous' : (dimension ?? '');
}

export function getGroupByMetadataKeys(usageTab: UsageTabKey, dimension: DimensionType): string[] {
  if (dimension === DimensionType.SDK_VERSION_V1) {
    return [V1_SDK_METADATA_KEYS.sdk, V1_SDK_METADATA_KEYS.version, V1_SDK_METADATA_KEYS.type];
  }
  return getGroupByDimensions(usageTab, dimension).map(getDimensionMetadataKey);
}
